<template>
  <Public header="register">
    <v-app id="app" class="public mt-10">
      <v-main>
        <v-container>
          <v-row align="center" justify="center">
            <v-col cols="12" md="8" class="mb-16">
              <v-card class="elevation-0 pa-2">
                <v-card-text class="text--primary">
                  <form ref="form" @submit="submit" id="register">
                    <v-row>
                      <v-col cols="12" md="6" class="pb-0 pt-0">
                        <v-text-field
                          v-model="nameTH" outlined
                          label="ชื่อ (Thai) *"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6" class="pb-0 pt-0">
                        <v-text-field
                          v-model="lastNameTH" outlined
                          label="นามสกุล (Thai) *"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="6" class="pb-0 pt-0">
                        <v-text-field
                          v-model="nameEN" outlined
                          label="ชื่อ (English) *"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6" class="pb-0 pt-0">
                        <v-text-field
                          v-model="lastNameEN" outlined
                          label="นามสกุล (English) *"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="pb-0 pt-0">
                        <v-text-field
                          v-model="phone" outlined
                          label="เบอร์โทรศัพท์"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="pb-0 pt-0">
                        <v-text-field
                          v-model="email" outlined
                          label="อีเมล *"
                          required
                          :error-messages="registerError"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="pb-0 pt-0">
                        <v-text-field
                          v-model="password" outlined
                          :append-icon="show1 ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                          :rules="[rules.required, rules.min]"
                          :type="show1 ? 'text' : 'password'"
                          name="input-10-1"
                          label="รหัสผ่าน *"
                          @click:append="show1 = !show1"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-checkbox v-model="checkbox" outlined required>
                      <template v-slot:label>
                        <div>
                          ฉันยอมรับใน
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <a
                                target="_blank"
                                href="#"
                                @click.stop
                                v-on="on"
                              >
                                ข้อตกลงการใช้บริการโปรแกรมภาษีเจริญ
                              </a>
                            </template>
                            Opens in new window
                          </v-tooltip>
                        </div>
                      </template>
                    </v-checkbox>

                  </form>
                </v-card-text>
                <v-card-actions style="width: 50%; margin: 0 auto;">
                  <v-btn class="mr-4 tw-rounded-lg tw-h-11 tw-font-bold tw-text-base" type="submit" color="primary" block form="register">สมัครใช้งาน</v-btn>
                </v-card-actions>
                <v-divider style="margin-top: 20px; height: 1px"></v-divider>
                <div style="text-align: center; margin-top: 10px">
                  <span class="mr-2">มีบัญชีอยู่แล้ว</span>
                  <span class="pointer" style="color: #6ec39b" @click="redirectToLogin">เข้าสู่ระบบ</span>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
        <footer-web></footer-web>
      </v-main>
    </v-app>
  </Public>
</template>

<script>
import Public from '@/components/public/public-main-template'
import FooterWeb from '@/components/public/footer'
import router from '@/router'
import {mapState} from "vuex";

export default {
  name: 'Register',
  components: {
    Public,
    FooterWeb
  },
  computed: mapState({
    registerError: state => state.user.registerError,
  }),
  data() {
    let urlParams = new URLSearchParams(window.location.search);
    let email = "";
    try {
      if (urlParams.get('email')) {
        email = urlParams.get('email').replace("%40", "@")
      }
    } catch (e) {
      console.log(e)
    }

    return {
      email: email,
      nameTH: null,
      lastNameTH: null,
      nameEN: null,
      lastNameEN: null,
      phone: null,
      checkbox: null,
      show1: false,
      password: "",
      rules: {
        required: value => !!value || 'กรุณากรอกข้อมูล',
        min: v => v.length >= 6 || 'จำนวนน้อยที่สุด 6 ตัวอักษร',
        // emailMatch: () => (`The email and password you entered don't match`),
      },
    }
  },
  created() {
    this.$store.dispatch('auth/logoutWithoutRedirect')
  },
  methods: {
    submit: function (e) {
      e.preventDefault();
      if (this.password) {
        this.$store.dispatch('user/register', {registerData: this._data})
      }
    },
    redirectToLogin: function (e) {
      e.preventDefault();
      router.push('/login')
    }
  }
}
</script>

<style lang="scss">
* {
  font-family: "Noto Sans Thai", "Noto Sans", sans-serif;
}

.register-logo {
  width: 100px;
  display: block;
  margin: 20px auto;
}

fieldset {
  border-radius: 10px !important;
}

.pointer {
  cursor: pointer;
}
</style>
